import { render, staticRenderFns } from "./device-infos-updated.vue?vue&type=template&id=efb445e2&scoped=true"
import script from "./device-infos-updated.vue?vue&type=script&lang=js"
export * from "./device-infos-updated.vue?vue&type=script&lang=js"
import style0 from "./device-infos-updated.vue?vue&type=style&index=0&id=efb445e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb445e2",
  null
  
)

export default component.exports